<template>
    <div class="wrapper-form-block-nomefantasia" :class="{'allow-markup-error': markupError}" :inert="pPreview">
        <TrfInput
            label="Nome fantasia"
            placeholder="Nome fantasia"
            margin="0"
            id="form-block-nomefantasia"
            v-model="formData.nomeFantasia"
            maxLength="50"
            ref="BlockNomeFantasia"
            v-e2e="'form-block-nomefantasia'"
            @update:modelValue="setNomeFantasia"
            :required="false"
        ></TrfInput>
        <p class="error-message" v-if="markupError">
          Campo obrigatório!
        </p>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  export default {
    name: 'TrfBlocoNomeFantasia',
    emits: ['update:form-data', 'set:validacao'],
    components: {
        TrfInput: defineAsyncComponent(() => import('../../Input/index.vue'))
    },
    props: {
        pNomeFantasia: {
            type: String,
            default: ''
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        pIsDirty: {
            type: Boolean,
            default: false
        },
        pCampo: {
            type: Object,
            default: () => {}
        },
        pEmpresa: {
            type: Object,
            default: () => {}
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        formData: {
            nomeFantasia: this.pEmpresa?.nomeFantasia? `${this.pEmpresa.nomeFantasia}` : this.pNomeFantasia
        },
        isDirty: this.pIsDirty
      };
    },
    computed: {
        isInvalida() {
          if (!this.required) return false;
          return this.isDirty && !this.formData.nomeFantasia?.trim()
        },
        markupError() {
          return !this.pPreview && this.isInvalida
        }
    },
    watch: {
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        }
    },
    methods: {
        setNomeFantasia(nomeFantasia) {
            this.formData.nomeFantasia = nomeFantasia ? nomeFantasia : ''; //garante tipo
            this.emitFormData(this.formData)
            this.isDirty = true;
        },
        emitFormData(formData = this.formData) {
            this.$emit('update:form-data', formData)
        }
    }
  };
  </script>
  